export default __webpack_public_path__ + "static/media/Arch_Amazon-Simple-Queue-Service_64.ea1b83c8.svg";